const ACTION_PARAMETERS_PRESETS = {
  API_ONLY: {
    ctxValidator: {
      meta: {
        type: 'object',
        props: {
          _requestSource: {
            type: 'string',
            enum: [ 'API' ]
          }
        }
      }
    }
  },
  INTERNAL_ONLY: {
    ctxValidator: {
      meta: {
        type: 'object',
        props: {
          _requestSource: 'forbidden'
        }
      }
    }
  },
  AUTHORIZED_ONLY: {
    ctxValidator: {
      meta: {
        type: 'object',
        props: {
          user: {
            type: 'object',
            props: {
              id: 'uuid'
            }
          },
          asUser: {
            type: 'object',
            props: {
              id: 'uuid'
            }
          }
        }
      }
    }
  },
  SUDO_ONLY: {
    ctxValidator: {
      meta: {
        type: 'object',
        props: {
          user: {
            type: 'object',
            props: {
              sudo: {
                type: 'eq',
                value: true
              }
            }
          }
        }
      }
    }
  },
  NOT_SUDO_ONLY: {
    ctxValidator: {
      meta: {
        type: 'object',
        props: {
          user: {
            type: 'object',
            props: {
              sudo: {
                type: 'eq',
                value: false
              }
            }
          }
        }
      }
    }
  }
}

module.exports = {
  ACTION_PARAMETERS_PRESETS
}
